var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.selectedSorting,
          expression: "selectedSorting",
        },
      ],
      staticClass: "custom-select nti-product-tile-grid__sort",
      on: {
        change: [
          function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.selectedSorting = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
          _vm.performSearchWithSort,
        ],
      },
    },
    [
      _c(
        "option",
        { attrs: { selected: "" }, domProps: { value: _vm.selectedSorting } },
        [
          _vm._v(
            _vm._s(_vm.verifyLabel(_vm.options[_vm.selectedSorting].label))
          ),
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.options, function (option, index) {
        return [
          _vm.selectedSorting !== index
            ? _c("option", { key: index, domProps: { value: index } }, [
                _vm._v(_vm._s(_vm.verifyLabel(option.label))),
              ])
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }